// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__35Cxr","title":"AfterFrontImage_title__6zaLw"};